module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/logo_jssr-d1f4eb80fa3bd79233ffa3062aec84da.svg";